import { GridLegacy as Grid, Typography } from '@mui/material';

import { QuestionType } from '~/data/surveys';

import { BarChart, DonutChart, LikertChart } from '../ResultsFields';
import { BarData, DonutData, LikertData, SurveyResultsData } from '../types';

type Props = {
  data: SurveyResultsData;
};

const renderComments = (comObj: SurveyResultsData) => (
  <Grid item sm={12} md={6} key={`${comObj.type}-${comObj.id}`}>
    <Typography variant="h6">{comObj.title}</Typography>
    {(comObj.answers as string[]).map((c: string, index: number) => (
      <Typography key={index} variant="body2">
        {index + 1}. {c}
      </Typography>
    ))}
  </Grid>
);

export const RenderChart: React.FC<Props> = ({ data }) => {
  if (data.type === QuestionType.YES_NO) {
    return (
      <Grid item key={`${data.type}-${data.id}`}>
        <DonutChart
          data={data.answers as DonutData[]}
          title={data.title}
          total={data.total}
          percentageLabel
        />
      </Grid>
    );
  }

  if (data.type === QuestionType.SCALE && data.legend) {
    return (
      <Grid item key={`${data.type}-${data.id}`}>
        <LikertChart
          data={data.answers as LikertData[]}
          legendData={data.legend}
          title={data.title}
          total={data.total}
        />
      </Grid>
    );
  }

  if (
    data.type === QuestionType.MULTIPLE_CHOICE ||
    data.type === QuestionType.SINGLE_CHOICE
  ) {
    return (
      <Grid item key={`${data.type}-${data.id}`}>
        <BarChart data={data.answers as BarData[]} title={data.title} />
      </Grid>
    );
  }

  if (data.type === QuestionType.FREE_TEXT) {
    return renderComments(data);
  }

  return null;
};
